var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeguro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.3532 29.0375C88.2833 28.3303 88.035 27.6523 87.6317 27.0672C87.2284 26.4821 86.6831 26.0089 86.0471 25.6919L52.3804 8.85852C51.7957 8.56596 51.151 8.41364 50.4972 8.41364C49.8434 8.41364 49.1986 8.56596 48.614 8.85852L14.9473 25.6919C14.313 26.0107 13.7694 26.4844 13.367 27.0693C12.9646 27.6541 12.7164 28.3311 12.6453 29.0375C12.599 29.4878 8.60112 74.3486 48.7907 92.2214C49.3277 92.4637 49.9101 92.5891 50.4993 92.5891C51.0884 92.5891 51.6709 92.4637 52.2079 92.2214C92.3975 74.3486 88.3995 29.492 88.3532 29.0375ZM50.4993 83.7332C22.0131 69.9635 20.6664 40.5767 20.8979 32.1306L50.4993 17.3299L80.0797 32.1222C80.2354 40.4926 78.6993 70.0729 50.4993 83.7332Z",
    fill: "#DA0067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2917 52.9661L36.642 43.3164L30.6914 49.267L46.2917 64.8673L70.3087 40.8503L64.3581 34.8997L46.2917 52.9661Z",
    fill: "#DA0067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguro);
export default __webpack_public_path__ + "static/media/seguro.06a3625c379a47aa99d868c71b518018.svg";
export { ForwardRef as ReactComponent };